import React, { useState } from 'react';

import Icone from 'Component/Icone';
import {
  useAdicionarAulaConcluidaMutation,
  useRemoverAulaConcluidaMutation,
} from 'Service';

interface Props {
  aulaId: number;
  aulaConcluidaId?: number;
}

const Botao = ({ aulaId, aulaConcluidaId }: Props): JSX.Element => {
  const [estado, setEstado] = useState<boolean>(!!aulaConcluidaId);

  const [adicionar, { isLoading: adicionando }] =
    useAdicionarAulaConcluidaMutation();
  const [remover, { isLoading: removendo }] = useRemoverAulaConcluidaMutation();

  const marcar = async (): Promise<void> => {
    if (!adicionando && !removendo) {
      setEstado(!estado);
      await adicionar({ aula_id: aulaId }).unwrap();
    }
  };

  const desmarcar = async (): Promise<void> => {
    if (aulaConcluidaId && !adicionando && !removendo) {
      setEstado(!estado);
      await remover({ id: aulaConcluidaId }).unwrap();
    }
  };

  return (
    <>
      {estado ? (
        <span className="cursor-pointer fs-5 px-3" onClick={desmarcar}>
          <Icone nome="check-circle-fill" className="text-success" />
        </span>
      ) : (
        <span className="cursor-pointer fs-5 px-3" onClick={marcar}>
          <Icone nome="circle" />
        </span>
      )}
    </>
  );
};

export default Botao;
